import {Injectable} from '@angular/core';
import {GeneralService} from '../../services/general.service';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs/Rx';

@Injectable()
export class PasswordResetService extends GeneralService {

    static DEFAULT_COMPANY_NAME = 'Comparatio';
    static DEFAULT_COMPANY_LOGO = '/img/comparatiologo.png';

    constructor(
        protected http: HttpClient
    ) {
        super(http);
    }

    public requestPasswordReset(data: any): Observable<any> {
        const url = `${this.apiUrl}/site/request-password-reset`;
        return this.http.post(url, data);
    }

    public confirmPasswordReset(data: any): Observable<any> {
        const url = `${this.apiUrl}/site/password-reset`;
        return this.http.post(url, data);
    }

}



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/auth/password-reset/password-reset.service.ts